import { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import CreateStudentInClassForm from "../Forms/CreateStudentInClassForm";
import StudentLicenseManagemenModal from "./StudentLicenseManagemenModal";
import useCartStore from "../../stores/useCartStore";

export default function CreateStudentInClass(props) {
  const { key: locationKey } = useLocation();
  const [studentsForLicenseModal, setStudentsForLicenseModal] = useState([]);
  const clearCart = useCartStore((s) => s.clearCart);

  useEffect(() => {
    setStudentsForLicenseModal([]);
  }, [locationKey]);

  const closeAndAddLicense = (student) => {
    props.toggle();
    clearCart();
    setStudentsForLicenseModal([{ id: student.id, class: props.schoolClass }]);
  };

  const closeLicenseModal = () => {
    clearCart();
    setStudentsForLicenseModal([]);
  };

  return (
    <>
      <Modal
        size="lg"
        isOpen={props.addNewStudentToClassModal}
        toggle={props.toggle}
      >
        <ModalHeader>
          <FormattedMessage
            id="CreateAndAddStudentToClass"
            values={{ className: props.schoolClass?.name }}
          />
        </ModalHeader>
        <ModalBody>
          <CreateStudentInClassForm
            toggle={props.toggle}
            toggleAndAddLicense={closeAndAddLicense}
            classId={props.schoolClass?.id}
            purchaserTeacher={props.purchaserTeacher}
          />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
      <StudentLicenseManagemenModal
        isOpen={studentsForLicenseModal.length > 0}
        toggle={closeLicenseModal}
        preselectedStudents={studentsForLicenseModal}
      />
    </>
  );
}
